import styled, { css } from 'styled-components'

export const Container = styled.div`
  position: relative;

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
`

export const ButtonArea = styled.button<{ $loading?: boolean }>`
  background: none;
  border: 0;

  color: ${({ theme }) => (theme.isDark ? '#A7A7A7' : '#4A4A4A')};

  width: 100%;

  display: flex;
  gap: 14px;
  align-items: center;
  justify-content: space-between;

  background: ${({ theme }) => (theme.isDark ? `rgb(${theme.grayscale[400]})` : 'white')};

  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => (theme.isDark ? '#595959' : '#CFCFCF')};

  border-radius: 4px;

  padding: 18px 20px !important;

  transition: filter 0.3s ease, opacity 0.3s ease;

  &:hover {
    filter: brightness(0.98);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;

    &:hover {
      filter: brightness(0.9);
    }
  }

  ${({ $loading }) =>
    $loading &&
    css`
      opacity: 0.6;
      cursor: progress;

      &:hover {
        filter: brightness(0.9);
      }
    `}

  .wrap {
    display: flex;
    align-items: center;
    justify-content: start;

    gap: 8px;

    width: 88%;
  }

  .label {
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;

    display: inline-block;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    margin: 0;
  }
`

export const Dropdown = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  z-index: 10;

  box-shadow: 0px 4px 20px 0px #00000040;

  background: ${({ theme }) => (theme.isDark ? `rgb(${theme.grayscale[400]})` : 'white')};

  border-radius: 2px;
  overflow: hidden;

  display: flex;
  flex-direction: column;

  transform: translateY(calc(100% + 6px));

  .fixed-size-list {
    ::-webkit-scrollbar-track {
      background: ${({ theme }) => (theme.isDark ? `rgb(${theme.grayscale[400]})` : 'white')};
    }
  }
`

export const Search = styled.label`
  border-radius: 4px;
  width: 100%;

  padding: 8px 16px;

  display: flex;
  align-items: center;

  gap: 16px;

  box-shadow: 0px 4px 5px 0px #0000001a;

  z-index: 10;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;

    width: 24px;
    height: 24px;

    svg {
      color: ${({ theme }) => (theme.isDark ? '#A7A7A7' : '#5E6871')};
    }
  }

  input {
    border: none;
    background: transparent;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    width: 100%;

    font-size: 14px;
    font-weight: 400;
    line-height: 19px;

    &::placeholder {
      font-size: 14px;
      font-weight: 400;
      line-height: 19px;

      color: #a7a7a7;
    }
  }
`

export const Option = styled.button`
  position: relative;

  padding: 10px 20px;
  background: none;
  border: 0;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  gap: 20px;

  max-width: 100%;

  transition: filter 0.3s ease;

  background: ${({ theme }) => (theme.isDark ? `rgb(${theme.grayscale[400]})` : 'white')};

  &:hover {
    filter: brightness(0.95);
  }

  &[data-selected='true'] {
    filter: brightness(0.9);
  }

  .label {
    color: ${({ theme }) => (theme.isDark ? '#A7A7A7' : '#4A4A4A')};

    font-family: Montserrat;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;

    display: inline-block;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .checkbox {
    .indicator {
      width: 14px;
      height: 14px;

      border-radius: 4px;
      border-width: 1px;
      border-style: solid;
      border-color: ${({ theme }) => (theme.isDark ? '#A7A7A7' : '#CFCFCF')};

      background-color: transparent;

      &[data-checked='true'] {
        border: 2px solid ${({ theme }) => `rgb(${theme.primary.base})`};
        background-color: ${({ theme }) => `rgb(${theme.primary.base})`};
      }
    }
  }
`
